import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appFakeSeriesIfEmpty'
})
export class FakeSeriesIfEmptyPipe implements PipeTransform {
  public transform(value: any): any {
    if (value?.length) {
      return value;
    }

    return Array(15)
      .fill(0)
      .map(() => Math.random() * 10);
  }
}
